import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { TemplateApi } from "../../../utils/api/Template";
import { getUserId } from "../../../utils/helpers/common";
import CloseIcon from "../../../components/icons/CloseIcon";
import DownArrowIcon from "../../../components/icons/DownArrowIcon";
import Loading from "../../loading/Loading";
import SearchIcon from "../../../components/icons/SearchIcon";
import "./SearchFilterSelector.scss";
import { AgencyApi } from "../../../utils/api/Agency";
import { AgentApi } from "../../../utils/api/Agent";

let searchTimer: any;
let initialLoading = true;
const SearchFilterSelector = ({
  formik,
  lable,
  formik_key_id,
  formik_key_name,
}: {
  formik: any;
  lable: string;
  formik_key_id: string;
  formik_key_name: string;
}) => {
  const [state, setState] = useState({
    agentListBox: false,
    listData: [],
    isLoading: true,
    search: formik.values[formik_key_name],
  });

  const onToggelBox = () => {
    setState({
      ...state,
      agentListBox: !state?.agentListBox,
    });
  };

  const onClickSelect = (data: any) => {
    formik.setFieldValue(formik_key_id, data?._id);
    formik.setFieldValue(formik_key_name, data?.name);
    setState({
      ...state,
      agentListBox: !state?.agentListBox,
      search: data?.name,
    });
  };

  const onClickRemove = () => {
    formik.setFieldValue(formik_key_id, "");
    formik.setFieldValue(formik_key_name, "");
    initialLoading = true;
    setState({
      ...state,
      agentListBox: !state?.agentListBox,
      search: "",
    });
  };

  const getDataApi = async (search: string) => {
    setState({
      ...state,
      isLoading: true,
    });
    let res: any;

    switch (lable) {
      case "Agency":
       res = await AgencyApi?.SearchAgencyList(search, 100, "completed");
        break;
      case "Agent":
        res = await AgentApi?.SearchAgentList(search, 100, "completed");
        break;
      case "Brand":
        res = await TemplateApi?.getBrandList({ search });
        console.log("Brand ID sending to API:", formik.values.brand_id);
        console.log("Brand API response:", res?.data?.data?.docs);
        break;
      case "Suburb/City":
        res = await TemplateApi?.getBrandList({ search });
        break;
    }

    if (res?.data?.success) {
      let shortData: any;

      switch (lable) {
        case "Agency":
          shortData = res?.data?.data?.docs?.map((data: any) => {
            return {
              _id: data?._id,
              name: data?.agency_trading_name,
            };
          });
          break;
        case "Agent":
          shortData = res?.data?.data?.docs?.map((data: any) => {
            return {
              _id: data?._id,
              name: `${data?.principal_agent_first_name} ${data?.principal_agent_last_name}`,
            };
          });
          break;
        case "Brand":
          shortData = res?.data?.data?.docs?.map((data: any) => {
            return {
              _id: data?._id,
              name: `${data?.brand_name}`,
            };
          });

          break;

        case "Suburb/City":
          shortData = res?.data?.data?.docs?.map((data: any) => {
            return {
              _id: data?._id,
              name: `${data?.brand_name}`,
            };
          });

          break;
      }

      setState({
        ...state,
        isLoading: false,
        listData: shortData,
      });
      initialLoading = false;
    } else {
      setState({
        ...state,
        isLoading: false,
      });
      toast.error(res?.data?.message);
    }
  };

  const onChangeSearch = (e: any) => {
    let search = e?.target?.value;
    formik.setFieldValue(formik_key_name, search);
  };

  useEffect(() => {
    if (state?.listData) {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        getDataApi(formik.values[formik_key_name]);
      }, 500);
    }
  }, [formik.values[formik_key_name]]);

  useEffect(() => {
    getDataApi("");
  }, []);

  return (
    <div className="agent-info-input-contain-filter">
      <p className="lable">{lable}</p>
      <div className="template-selector-container">
        {state?.agentListBox && (
          <div className="agent-selector-bg" onClick={onToggelBox}></div>
        )}

        <div className="filter-search-agent">
          <div className="filter-search-icon">
            <SearchIcon />
          </div>

          <input
            type="text"
            placeholder={`Select ${lable}`}
            onClick={onToggelBox}
            onChange={onChangeSearch}
            disabled={formik?.values[formik_key_id] ? true : false}
            className={`common-filter-search-input`}
            value={formik?.values[formik_key_name]}
          />

          <div
            className={`filter-down-arrow-icon ${
              state?.agentListBox ? "open-box" : ""
            }`}
          >
            {initialLoading && state?.isLoading ? (
              <CircularProgress
                style={{
                  width: 20,
                  height: 20,
                  color: "black",
                  marginTop: "-2px",
                }}
              />
            ) : formik?.values[formik_key_id] ? (
              <div
                className="reporting-manager-close-icon"
                onClick={onClickRemove}
              >
                <CloseIcon />
              </div>
            ) : (
              <div onClick={onToggelBox}>
                <DownArrowIcon />
              </div>
            )}
          </div>
        </div>

        <div
          className={`reporting-manager-list-container ${
            state?.agentListBox ? "" : "display-none"
          }`}
        >
          {state?.isLoading ? (
            <Loading />
          ) : state?.listData?.length ? (
            state?.listData?.map((data: any) => (
              <div
                className={`reporting-manager-list-item`}
                key={data?._id}
                onClick={() => onClickSelect(data)}
              >
                <p className="item-profile-name">{data?.name}</p>
              </div>
            ))
          ) : (
            <div className="agent-list-not-found">
              <p>List not found!</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchFilterSelector;
